import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

export default function Menu({ variant = "site" }) {
  return (
    <nav className="flex justify-center md:justify-between items-center pt-8 md:py-8 px-4 max-w-7xl w-full">
      <h6 className="text-cabinet text-secondary font-black md:text-base text-xl">
        Quentin Robert
      </h6>
      <ul className="hidden md:flex gap-4 items-center">
        {variant === "site" && (
          <>
            <HashLink to="#portfolio">Portfolio</HashLink>
            <HashLink to="#process">Process</HashLink>
          </>
        )}
        <a href="https://wa.me/message/4QESRNQVOAAXK1" target="_blank" rel="noreferrer">Contact</a>
        {variant === "home" ? (
          <Link to="/site" className="bg-yellow text-secondary py-2 px-4 rounded-full text-sm font-semibold">Besoin d'un site ?</Link>
        ) : (
          <Link to="/" className="bg-yellow text-secondary py-2 px-4 rounded-full text-sm font-semibold">Besoin d'organiser votre activité ?</Link>
        )}
      </ul>
      {variant === "home" ? (
        <Link to="/site" className="fixed md:hidden bottom-6 left-1/2 -translate-x-1/2 z-50 bg-yellow text-secondary py-3 px-6 rounded-full text-sm font-semibold shadow-lg">
          Besoin d'un site ?
        </Link>
      ) : (
        <Link to="/" className="fixed md:hidden bottom-6 left-1/2 -translate-x-1/2 z-50 bg-yellow text-secondary py-3 px-6 rounded-full text-sm font-semibold shadow-lg">
          Organiser votre activité
        </Link>
      )}
    </nav>
  );
}
